module.exports = __webpack_public_path__ + "img/welding-2.8bf8d33c.jpg";